<template>
    <div>
        <!-- Button trigger -->

        <el-popover
            ref="popover4"
            placement="right"
            transition=""
            width="auto"
            popperClass="listing-dropdown"
            trigger="hover"
        >
            <template #reference>
                <a class="pointer">
                    <slot name="triggerbutton">trigger</slot>
                </a>
            </template>
            <slot name="content">No data</slot>
            <slot name="actionbuttons"></slot>
        </el-popover>
    </div>
</template>

<script>
export default {
    props: [],
    data() {
        return {};
    },
    methods: {},
};
</script>
